
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.084 28.033a1.03 1.03 0 01-.701-.273L.666 23.455a1.037 1.037 0 01-.066-1.47 1.036 1.036 0 011.47-.07l4.102 3.745 4.56-3.168a1.04 1.04 0 111.19 1.709l-5.246 3.645c-.178.127-.38.187-.592.187z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.084 26.041A1.042 1.042 0 015.043 25c0-11.008 8.977-19.965 20.008-19.965 8.637 0 16.27 5.49 18.992 13.662a1.041 1.041 0 11-1.977.658C39.63 12.037 32.79 7.117 25.053 7.117c-9.883 0-17.926 8.023-17.926 17.88a1.04 1.04 0 01-1.041 1.042l-.002.002zM48.633 28.463a1.03 1.03 0 01-.719-.29l-4.017-3.835-4.631 3.064a1.041 1.041 0 01-1.15-1.736l5.325-3.525c.4-.268.942-.221 1.293.117l4.618 4.412a1.04 1.04 0 01-.721 1.793h.002z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M25.051 44.965c-8.636 0-16.272-5.49-18.992-13.666a1.038 1.038 0 01.658-1.314 1.038 1.038 0 011.317.656 17.897 17.897 0 0017.013 12.24c9.883 0 17.926-8.024 17.926-17.881a1.042 1.042 0 012.082 0c.002 11.01-8.972 19.967-20.006 19.967l.002-.002z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M25.051 31.25a6.258 6.258 0 01-6.25-6.25 6.258 6.258 0 016.25-6.25 6.26 6.26 0 016.25 6.25 6.258 6.258 0 01-6.25 6.25zm0-10.416A4.17 4.17 0 0020.885 25c0 2.3 1.867 4.166 4.166 4.166A4.169 4.169 0 0029.217 25a4.172 4.172 0 00-4.166-4.166z","fill":"currentColor"}})])
          )
        }
      }
    